import apiClient from "../api/apiClient";
import { API_ENDPOINTS } from "../api/endpoints";
import { setToken, removeToken } from "../utils/tokenStorage";

/**
 * Authentication Service
 * Handles login, registration, and logout operations.
 */

const authService = {
  login: async (credentials) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, credentials);
      // Assuming the API returns { token: '...' } or similar
      if (response && response.data.token) {
        setToken(response.data.token);
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  register: async (data) => {
    try {
      return await apiClient.post(API_ENDPOINTS.AUTH.REGISTER, data);
    } catch (error) {
      throw error;
    }
  },

  changePassword: async (passwordData) => {
    try {
      return await apiClient.put(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, passwordData);
    } catch (error) {
      throw error;
    }
  },

  logout: async () => {
    try {
      // Optional: inform backend about logout
      // await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
    } finally {
      removeToken();
      if (typeof window !== 'undefined') {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/';
      }
    }
  },
};

export default authService;
